// extracted by mini-css-extract-plugin
export default {"content":"SdbgPasswordReset_content__sV0CC","main":"SdbgPasswordReset_main__ry9g4"};